import React, { useState, useEffect } from "react";
import Google from "./../../../assets/google-play.svg";
import AppStore from "./../../../assets/apple-store.svg";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  useMediaQuery,
} from "@mui/material";
import BlueButton from "../../../components/BlueButton/BlueButton";
import api from "../../../utils/api"; // Import your API instance

const AppLinks = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");

  // State to store app links
  const [appLinks, setAppLinks] = useState({
    googlePlay: "",
    appStore: "",
    address: "",
    email: "",
    phone: "",
  });

  // Loading state
  const [loading, setLoading] = useState(false);

  // Fetch app links on component mount
  useEffect(() => {
    fetchAppLinks();
  }, []);

  // Function to fetch app links from API
  const fetchAppLinks = async () => {
    try {
      setLoading(true);
      const res = await api.get("/apps-links");

      if (res.data && res.data.data) {
        setAppLinks({
          googlePlay: res.data.data.googlePlay || "",
          appStore: res.data.data.appStore || "",
          address: res.data.data.address || "",
          email: res.data.data.email || "",
          phone: res.data.data.phone || "",
        });
      }
    } catch (error) {
      console.error("Failed to fetch app links:", error);
      // You can integrate with your react-notify library here
    } finally {
      setLoading(false);
    }
  };

  // Function to update app links
  const updateAppLinks = async () => {
    try {
      setLoading(true);

      // Create FormData for API compatibility
      const formData = new FormData();
      formData.append("googlePlay", appLinks.googlePlay);
      formData.append("appStore", appLinks.appStore);
      formData.append("address", appLinks.address);
      formData.append("email", appLinks.email);
      formData.append("phone", appLinks.phone);

      const res = await api.post("/update-appLinks", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data && res.data.status === 200) {
        // You can integrate with your react-notify library here for success notification
      }
    } catch (error) {
      console.error("Failed to update app links:", error);
      // You can integrate with your react-notify library here for error notification
    } finally {
      setLoading(false);
    }
  };

  // Handle input change
  const handleInputChange = (field, value) => {
    setAppLinks((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="departments-container ">
      <form action="" className="links-container">
        <div className="control-group">
          <img src={Google} alt="" />
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="google-play-link"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رابط جوجل بلاي
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              required
              id="google-play-link"
              type="text"
              value={appLinks.googlePlay}
              onChange={(e) => handleInputChange("googlePlay", e.target.value)}
            />
          </FormControl>
        </div>

        <div className="control-group">
          <img src={AppStore} alt="" />
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="app-store-link"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رابط اب ستور
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              required
              id="app-store-link"
              type="text"
              value={appLinks.appStore}
              onChange={(e) => handleInputChange("appStore", e.target.value)}
            />
          </FormControl>
        </div>
        <div className="control-group">
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="address"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              العنوان
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              id="address"
              type="text"
              value={appLinks.address}
              onChange={(e) => handleInputChange("address", e.target.value)}
            />
          </FormControl>
        </div>

        <div className="control-group">
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="email"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              البريد الإلكتروني
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              id="email"
              type="email"
              value={appLinks.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
            />
          </FormControl>
        </div>

        <div className="control-group">
          <FormControl
            sx={{ width: isMobile ? "100%" : "700px" }}
            variant="outlined"
          >
            <InputLabel
              htmlFor="phone"
              shrink
              sx={{
                background: "white",
                transformOrigin: "right top",
                transform: "translate(14px, -9px) scale(0.75)",
                right: 24,
                left: "auto",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              رقم الهاتف
            </InputLabel>
            <OutlinedInput
              sx={{ borderRadius: "8px" }}
              id="phone"
              type="text"
              value={appLinks.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
            />
          </FormControl>
        </div>
      </form>

      <div className="action-continer">
        <BlueButton
          text={loading ? "جاري الحفظ..." : "حفظ"}
          variant="fill"
          size="medium"
          onClick={updateAppLinks}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default AppLinks;
